import * as React from 'react';

import type { HiveWorkingDocument } from '@gitbook/hive-client';
import Hotkeys from '@gitbook/slate-hotkeys';
import type { Plugin } from '@gitbook/slate-react';

/**
 * Return a Slate plugin that syncs the history of a Slate document with a Hive page
 */
export function useHiveSlateHistoryPlugin(page: HiveWorkingDocument): Plugin {
    return React.useMemo(() => {
        return {
            onKeyDown(event, change) {
                if (Hotkeys.isRedo(event)) {
                    page.redo();
                    event.preventDefault();
                    return change;
                }

                if (Hotkeys.isUndo(event)) {
                    page.undo();
                    event.preventDefault();
                    return change;
                }
            },
        };
    }, [page]);
}
